<template>
  <VContainer fluid class="align-start" style="background: #DFDFDD">
    <!-- DESKTOP -->
    <div class="d-none d-lg-block">
      <VRow align="end">
        <VCol cols="12" align="end">
          <VCard class="elevation-0" color="transparent">
            <VCardTitle class="d-flex justify-end align-center text-right" style="gap:16px;">
              <VImg :src="hat" max-width="80px" /><span class="text-h2">{{ $t('MOBILE_PRESENTATION.title') }}</span>
            </VCardTitle>
          </VCard>
        </VCol>
      </VRow>

      <VContainer fluid>
        <VRow no-gutters justify="center" align="center">
          <VCol cols="6" class="d-flex justify-center">
            <VImg :src="mobile" />
          </VCol>

          <VCol cols="6" style="display:flex;justify-content:center;align-items:center;">
            <VBtn
              @click="startVideo"
              v-show="myVideo.paused"
              variant="text"
              class="elevation-0"
              style="position:absolute;z-index:9999;"
              icon
            >
              <VIcon size="70" color="primary">mdi-play-circle-outline</VIcon>
            </VBtn>

            <video
              ref="playerMobile"
              @pause="pauseVideo"
              @play="startVideo"
              controlsList="nodownload noplaybackrate"
              poster="@/assets/covers/video_cover.jpg"
              style="width:100%;"
              class="rounded-xl"
            >
              <source :src="video" type="video/mp4" />
            </video>
          </VCol>
        </VRow>
      </VContainer>
    </div>

    <!-- MOBILE -->
    <div class="d-md-none">
      <VRow align="start">
        <VCol cols="12">
          <VCard class="elevation-0" color="transparent">
            <VCardTitle class="text-h6">
              <VSpacer />
              <div class="d-flex justify-center align-center text-center">
                <VImg :src="hat" max-width="30px" /><span class="text-h6">{{ $t('MOBILE_PRESENTATION.title') }}</span>
              </div>
            </VCardTitle>
          </VCard>
        </VCol>
      </VRow>

      <VRow>
        <VCol cols="12">
          <VRow no-gutters justify="center" align="center">
            <VCol cols="12" class="d-flex justify-center">
              <VContainer class="d-flex justify-center">
                <VImg :src="mobile" />
              </VContainer>
            </VCol>

            <VCol cols="12" style="display:flex;justify-content:center;align-items:center;">
              <VBtn
                @click="startVideo"
                v-show="myVideo.paused"
                variant="text"
                class="elevation-0"
                style="position:absolute;z-index:9999;"
                icon
              >
                <VIcon size="70" color="primary">mdi-play-circle-outline</VIcon>
              </VBtn>

              <video
                ref="player"
                @pause="pauseVideo"
                @play="startVideo"
                controlsList="nodownload noplaybackrate"
                poster="@/assets/covers/video_cover.jpg"
                style="width:100%;"
                class="rounded-xl"
              >
                <source :src="video" type="video/mp4" />
              </video>
            </VCol>
          </VRow>
        </VCol>
      </VRow>
    </div>
  </VContainer>
</template>

<script>
import hat from '@/assets/icons/icons/hat.png'
import mobile from '@/assets/imgs/versao mobile 2.png'

export default {
  name: 'MobilePresent',
  data () {
    return {
      hat,
      mobile,
      // ideal: importar o mp4: import videoFile from '@/assets/video/RL_Video_apresentacao.mp4'
      // e usar video: videoFile
      video: 'video/RL_Video_apresentacao.mp4',
      myVideo: { paused: true }
    }
  },
  mounted () {
    this.setupVideos()
  },
  methods: {
    startVideo () {
      const v1 = this.$refs.player
      const v2 = this.$refs.playerMobile
      v1 && v1.play()
      v2 && v2.play()
      this.myVideo.paused = false
    },
    pauseVideo () {
      const v1 = this.$refs.player
      const v2 = this.$refs.playerMobile
      v1 && v1.pause()
      v2 && v2.pause()
      this.myVideo.paused = true
    },
    setupVideos () {
      const v = this.$refs.player
      if (!v) return
      v.controls = false
      v.addEventListener('mouseover', () => { v.controls = 'controls' })
      v.addEventListener('mouseout', () => { v.controls = false })
    }
  }
}
</script>
